(function () {
  'use strict';

  const header = document.querySelector('.a-header');
  if (!header) return;

  const triggers = [...header.querySelectorAll('[data-athena-trigger]')];
  const panels = [...header.querySelectorAll('[data-athena-mega]')];
  let openId = null;
  let closeTimer = null;

  function close(id) {
    const panel = document.getElementById(id);
    const trigger = triggers.find((t) => t.dataset.athenaTrigger === id);
    if (panel) {
      panel.classList.remove('is-open');
      setTimeout(() => {
        if (!panel.classList.contains('is-open')) panel.hidden = true;
      }, 180);
    }
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.closest('.a-header__item').classList.remove('is-open');
    }
    if (openId === id) openId = null;
    header.classList.toggle('a-header--mega-open', openId !== null);
  }

  function closeAll() {
    panels.forEach((p) => close(p.id));
  }

  function open(id) {
    if (openId && openId !== id) close(openId);
    const panel = document.getElementById(id);
    const trigger = triggers.find((t) => t.dataset.athenaTrigger === id);
    if (!panel) return;
    panel.hidden = false;
    requestAnimationFrame(() => panel.classList.add('is-open'));
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
      trigger.closest('.a-header__item').classList.add('is-open');
    }
    openId = id;
    header.classList.add('a-header--mega-open');
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeAll, 140);
  }

  triggers.forEach((trigger) => {
    const id = trigger.dataset.athenaTrigger;
    const item = trigger.closest('.a-header__item');

    item.addEventListener('mouseenter', () => { cancelClose(); open(id); });
    item.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focus', () => { cancelClose(); open(id); });
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (openId === id) close(id);
      else open(id);
    });
  });

  panels.forEach((panel) => {
    panel.addEventListener('mouseenter', cancelClose);
    panel.addEventListener('mouseleave', scheduleClose);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && openId) {
      const t = triggers.find((x) => x.dataset.athenaTrigger === openId);
      closeAll();
      if (t) t.focus();
    }
  });

  document.addEventListener('click', (e) => {
    if (openId && !header.contains(e.target)) closeAll();
  });

  const burger = header.querySelector('[data-athena-burger]');
  const drawer = header.querySelector('[data-athena-drawer]');
  if (burger && drawer) {
    burger.addEventListener('click', () => {
      const isOpen = !drawer.hidden;
      drawer.hidden = isOpen;
      burger.setAttribute('aria-expanded', String(!isOpen));
      burger.classList.toggle('is-open', !isOpen);
      document.body.classList.toggle('a-drawer-open', !isOpen);
    });
  }
})();
